import type { Connection } from '@libp2p/interface';

import type { ConnectionInfo } from '@/types/poc/libp2p';

export function extractConnectionInfo(connection: Connection): ConnectionInfo {
  const address = connection.remoteAddr.toString();
  return {
    peerId: connection.remotePeer.toString(),
    address,
    isDirect: address.includes('/webrtc/') && !address.includes('/p2p-circuit'),
    isRelay: address.includes('/p2p-circuit'),
    direction: connection.direction,
  };
}

// Infra peers (HAP + message broker) are identified by their peerId appearing inside one of
// the configured bootstrap multiaddrs.
export function isInfraPeer(peerId: string, bootstrapNodes: string[]): boolean {
  return bootstrapNodes.some((address) => address.includes(peerId));
}
